import moment from 'moment-business-days'
import React, { ReactElement, useMemo } from 'react'
import styled from 'styled-components'

import Button from '../../../../../../1stlog-ui/src/components/Button'
import ButtonGroup from '../../../../../../1stlog-ui/src/components/ButtonGroup'
import useFieldValue from '../../../../../../1stlog-ui/src/components/Field/useFieldValue'
import { useNextWorkingDay } from './queries'

const Wrapper = styled.div``

export type DatePresetsProps = {
  onChange: (value: string) => void
  value: string
}

const DatePresets = (props: DatePresetsProps): ReactElement => {
  const { onChange, value } = props

  const pickUpCountry = useFieldValue<string>('pickup.address.country', {
    ignorePrefix: true,
  })
  const pickupZip = useFieldValue<string>('pickup.address.zip', {
    ignorePrefix: true,
  })

  const { isLoading, data: nextWorkingDay } = useNextWorkingDay({
    country: pickUpCountry,
    zip: pickupZip,
  })

  const now = useMemo(() => moment(value).startOf('day').toISOString(), [value])
  const today = useMemo(() => moment().startOf('day').toISOString(), [])

  const setToday = (): void => {
    onChange(today)
  }

  const setNextBusiness = (): void => {
    if (!nextWorkingDay) {
      return
    }
    onChange(nextWorkingDay)
  }

  return (
    <Wrapper>
      <ButtonGroup>
        <Button rounded onClick={setToday} info={now === today}>
          {i18n.t('today', 'Heute')}
        </Button>
        <Button
          rounded
          onClick={setNextBusiness}
          info={now === nextWorkingDay}
          disabled={isLoading || (!isLoading && !nextWorkingDay)}
          isLoading={isLoading}
        >
          {i18n.t('next_workday', 'Nächster Werktag')}
        </Button>
      </ButtonGroup>
    </Wrapper>
  )
}

export default DatePresets
